import { Bell, BellOff, Check, Loader2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { usePushNotifications } from "@/hooks/usePushNotifications";
import { toast } from "sonner";

export function NotificationToggle({ evaluator }) {
  const {
    supported,
    permission,
    loading,
    isSubscribed,
    subscribe,
    unsubscribe
  } = usePushNotifications(evaluator);

  // Don't show for players or if not supported
  if (evaluator?.isPlayer || !supported) {
    return null;
  }

  const handleToggle = async () => {
    if (isSubscribed) {
      await unsubscribe();
      toast.success("Notificações desativadas");
    } else {
      await subscribe();
      if (permission === 'granted') {
        toast.success("Notificações ativadas!");
      }
    }
  };

  return (
    <Button
      variant={isSubscribed ? "default" : "outline"}
      size="sm"
      onClick={handleToggle}
      disabled={loading}
      className={`gap-2 ${isSubscribed ? 'bg-green-600 hover:bg-green-700 text-white' : ''}`}
      data-testid="notification-toggle-btn"
    >
      {loading ? (
        <Loader2 className="h-4 w-4 animate-spin" />
      ) : isSubscribed ? (
        <Bell className="h-4 w-4" />
      ) : (
        <BellOff className="h-4 w-4" />
      )}
      {isSubscribed ? "Notificações ON" : "Ativar Notificações"}
    </Button>
  );
}

export function NotificationCard({ evaluator }) {
  const {
    supported,
    permission,
    loading,
    isSubscribed,
    subscribe,
    unsubscribe
  } = usePushNotifications(evaluator);

  // Don't show for players
  if (evaluator?.isPlayer) {
    return null;
  }

  // Don't show if not supported
  if (!supported) {
    return null;
  }

  const handleToggle = async () => {
    if (isSubscribed) {
      await unsubscribe();
      toast.success("Notificações desativadas");
    } else {
      await subscribe();
      if (permission === 'granted') {
        toast.success("Notificações ativadas!");
      }
    }
  };

  return (
    <Card className="bg-card/80 backdrop-blur-md border border-border rounded-xl">
      <CardContent className="p-4">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-3">
            <div className={`w-10 h-10 rounded-full flex items-center justify-center ${
              isSubscribed ? 'bg-green-500/20' : 'bg-muted'
            }`}>
              {isSubscribed ? (
                <Bell className="h-5 w-5 text-green-500" />
              ) : (
                <BellOff className="h-5 w-5 text-muted-foreground" />
              )}
            </div>
            <div>
              <p className="font-medium text-foreground text-sm">
                Notificações Push
              </p>
              <p className="text-xs text-muted-foreground">
                {isSubscribed 
                  ? "Você será notificado sobre novos cadastros" 
                  : "Receba alertas de novos jogadores"}
              </p>
            </div>
          </div>
          <Button
            variant={isSubscribed ? "outline" : "default"}
            size="sm"
            onClick={handleToggle}
            disabled={loading}
            className="gap-2"
            data-testid="notification-card-toggle"
          >
            {loading ? (
              <Loader2 className="h-4 w-4 animate-spin" />
            ) : isSubscribed ? (
              <>
                <Check className="h-4 w-4" />
                Ativado
              </>
            ) : (
              "Ativar"
            )}
          </Button>
        </div>
      </CardContent>
    </Card>
  );
}

export default NotificationToggle;
